import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full border border-accent-300/50 bg-accent-100/60 text-accent-700 text-xs font-medium mb-4">
            Shop by Category
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-3">
            Explore Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Browse through our organized spreadsheet categories and discover the latest finds curated just for you.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative aspect-square rounded-2xl overflow-hidden cursor-pointer"
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                style={{ backgroundImage: `url('${cat.imageUrl}')` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-foreground-950/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-end pb-4 px-3">
                <span className="text-background-50 font-semibold text-sm md:text-base text-center leading-tight">
                  {cat.name}
                </span>
                <span className="text-background-50/80 text-xs mt-1 font-body opacity-0 group-hover:opacity-100 transition-opacity">
                  Shop Now →
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}